import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function patchClass(classId: any, data: any) {
    const { apiPatchClass } = apiConfig.getStaticUrls();

    return postFetch(`${apiPatchClass}${classId}/`, data);
}
